<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Início</li>
        </ol>
        <!-- Icon Cards-->
        <div class="row">
          <div v-if="mostraErro" class="alert alert-danger alert-dismissible col-12" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <strong>Ops!</strong>
            <span>{{mensagemErro}}</span>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card dashboard text-white bg-primary o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-envelope-open"></i>
                </div>
                <div class="mr-5">
                  <h5>{{plans}} Planos Cadastrados!</h5>
                </div>
              </div>
              <router-link class="card-footer text-white clearfix small z-1" to="/adm/planos">
                <span class="float-left">Detalhes</span>
                <span class="float-right">
                  <i class="fa fa-angle-right"></i>
                </span>
              </router-link>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card dashboard text-white bg-warning o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-star"></i>
                </div>
                <div class="mr-5">
                  <h5>{{subscriptions}} Assinaturas Ativas!</h5>
                </div>
              </div>
              <router-link class="card-footer text-white clearfix small z-1" to="/adm/assinantes">
                <span class="float-left">Detalhes</span>
                <span class="float-right">
                  <i class="fa fa-angle-right"></i>
                </span>
              </router-link>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card dashboard text-white bg-success o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-calendar-check-o"></i>
                </div>
                <div class="mr-5">
                  <h5>{{new_subscriptions}} Assinaturas do Mês!</h5>
                </div>
              </div>
              <router-link class="card-footer text-white clearfix small z-1" to="/adm/assinantes">
                <span class="float-left">Detalhes</span>
                <span class="float-right">
                  <i class="fa fa-angle-right"></i>
                </span>
              </router-link>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card dashboard text-white bg-danger o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-heart"></i>
                </div>
                <div class="mr-5">
                  <h5>R$ {{formataTextoEmNumeral(faturamento)}} Faturamento Mensal!</h5>
                </div>
              </div>
              <a
                class="card-footer text-white clearfix small z-1"
                target="_blank"
                href="https://minhaconta2.cielo.com.br/login/"
              >
                <span class="float-left">Detalhes</span>
                <span class="float-right">
                  <i class="fa fa-angle-right"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-area-chart"></i>Gerar Relatório
            </h2>
          </div>
          <div class="row">

            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a data de início</label>
                <date-picker
                  v-model="relatorio.inicio"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de inicio"
                ></date-picker>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a data de fim</label>
                <date-picker
                  v-model="relatorio.fim"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                  placeholder="Selecione uma data de fim"
                ></date-picker>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Corretor</label>
                <select id="corretores" @change="(e) => trocaCorretor(e)" class="form-control">
                  <option value="0" selected v-bind:key="0">Todos</option>
                  <template >
                    <option v-for="ct in corretores" :key="ct.id" :id="ct.id" :value="`${ct.id}`">
                      {{ct.name}}
                    </option>
                  </template>
                </select>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col-md-12">
              <button
                class="btn_1 medium pull-right ml-5"
                @click="gerarRelatorioPorOperadora"
              >Gerar Relatório por Operadora</button>

              <!-- <button
                class="btn_1 medium pull-right ml-5"
                @click="gerarRelatorio"
              >Gerar Relatório</button> -->

              <button
                class="btn_1 medium pull-right hidden"
                @click="gerarGraficos"
              >Atualizar Gráficos</button>
            </div>
          </div>

          <div class="hidden">
            <div class="row">
              <div class="col-md-12 mt-5">
                <LineChart
                  title="Quantidade de Encaminhamento por Campanha"
                  title_y="Nº de encaminhamento"
                  :xasis="campanhasPorDia.legends"
                  :data="campanhasPorDia.data"
                  width="100%"
                  :key="componentKey"
                />
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-md-10 m-auto" v-if="vendasPorPlano.data.length > 0">
                <PieChart
                  :legends="vendasPorPlano.legends"
                  :data="vendasPorPlano.data"
                  title="Quantidade de vendas por plano"
                  width="100%"
                  legendsPosition="right"
                  :key="componentKey"
                />
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-md-6" v-if="vendasBoletoECartao.qtd.length > 0 && (vendasBoletoECartao.qtd[0] > 0 || vendasBoletoECartao.qtd[1] > 0)">
                <PieChart
                  :legends="['Boleto', 'Cartão']"
                  :data="vendasBoletoECartao.qtd"
                  title="Quant. de vendas por boleto e cartão"
                  width="100%"
                  legendsPosition="bottom"
                  :key="componentKey"
                />
              </div>
              <div class="col-md-6" v-if="vendasBoletoECartao.valor.length > 0 && (vendasBoletoECartao.valor[0] > 0 || vendasBoletoECartao.valor[1] > 0)">
                <PieChart
                  :legends="['Boleto', 'Cartão']"
                  :data="vendasBoletoECartao.valor"
                  title="Valores das vendas por boleto e cartão"
                  width="100%"
                  legendsPosition="bottom"
                  :tooltip="(val) => 'R$ ' + val"
                  :key="componentKey"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 mt-5">
                <LineChart
                  title="Vendas Diárias"
                  name="Vendas"
                  title_y="Nº de vendas"
                  :xasis="vendasPorDia.legends"
                  :data="[
                    {
                      name: 'Quantidade',
                      data: vendasPorDia.data
                    }
                  ]"
                  width="100%"
                  :key="componentKey"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 mt-5">
                <BarChart
                  width="100%"
                  title="Quantidade de Assinaturas por Status"
                  legend_y="Status"
                  :xasis="['Ativas', 'Atrasadas', 'Suspensas']"
                  :data="[
                    {
                      name: 'Quantidade de assinaturas',
                      data: assinaturasPorStatus
                    }
                  ]"
                  :key="componentKey"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from "axios";
import moment from "moment";
import { VueEditor } from "vue2-editor";
import { Money } from "v-money";
import VueApexCharts from "vue-apexcharts";
import LineChart from "@/components/Charts/LineChart.vue";
import PieChart from "@/components/Charts/PieChart.vue";
import BarChart from "@/components/Charts/BarChart.vue";

export default {
  components: {
    apexcharts: VueApexCharts,
    LineChart,
    PieChart,
    BarChart,
  },
  mixins: [funcoesGerais],
  data: function () {
    return {
      lang: {
        days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        months: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dec"
        ],
        pickers: [
          "prox 7 dias",
          "prox 30 dias",
          "7 dias anteriores",
          "30 dias anteriores"
        ],
        placeholder: {
          date: "Selecione a data",
          dateRange: "Selecione o intervalo"
        }
      },
      faturamento: "",
      new_subscriptions: "",
      plans: "",
      subscriptions: "",
      mostraErro: "",
      mensagemErro: "",
      relatorio: {
        inicio: "",
        fim: ""
      },
      vendasPorDia: {
        legends: [],
        data: []
      },
      vendasPorPlano: {
        legends: [],
        data: []
      },
      vendasBoletoECartao: {
        valor: [],
        qtd: []
      },
      assinaturasPorStatus: [0, 0, 0],
      campanhasPorDia: {
        legends: [],
        data: []
      },
      corretores: [],
      corretor: null,
      isLoading: false,
      componentKey: 0
    };
  },

  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));

    if (user) {
      self.isLoading = true;

      const dataAtual = new Date();
      const dataAtualArray = dataAtual.toLocaleDateString().split("T")[0].split("/");
      this.relatorio.inicio = `01/${dataAtualArray[1]}/${dataAtualArray[2]}`;
      this.relatorio.fim = `${dataAtualArray[0]}/${dataAtualArray[1]}/${dataAtualArray[2]}`;
      this.gerarGraficos();

      axios.get(`corretores`)
        .then((corretoresRes) => {
          self.corretores = corretoresRes.data;
          self.isLoading = false;
        }).catch((err) => {
            self.isLoading = false;
            tratamento_requisicao(err, this);
        });

      ajax("get", "/dashboard/cards_geral")
        .then((response) => {
          self.isLoading = false;
          self.faturamento = response.faturamento;
          self.new_subscriptions = response.new_subscriptions;
          self.plans = response.plans;
          self.subscriptions = response.subscriptions;
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    } else {
      this.$router.push("/");
    }
  },

  methods: {
    trocaCorretor(e){
      this.corretor = e.target.value;
    },
    gerarRelatorio(){
      this.isLoading = true;
      if(!this.corretor)
        this.corretor = 0;
      this.relatorio.id_corretor = this.corretor;
      ajax("post", "relatorio", this.relatorio)
      .then(response => {
        this.isLoading = false;
        window.open(response, "_blank");
        alerta("success", "Sucesso", "Relatório gerado com sucesso");
      })
      .catch(err => {
        this.isLoading = false;
        tratamento_requisicao(err);
      })
    },
    gerarRelatorioPorOperadora(){
      this.isLoading = true;
      ajax("post", "relatorio_por_operadora", this.relatorio)
      .then(response => {
        this.isLoading = false;
        response.forEach(relatorio => {
          window.open(relatorio.url, "_blank");
        });
        alerta("success", "Sucesso", "Relatórios gerados com sucesso para cada operadora");
      })
      .catch(err => {
        this.isLoading = false;
        tratamento_requisicao(err);
      })
    },
    gerarGraficos(){
      this.isLoading = true;

      this.vendasPorDia = {
        legends: [],
        data: []
      };
      this.vendasPorPlano = {
        legends: [],
        data: []
      };
      this.vendasBoletoECartao = {
        valor: [],
        qtd: []
      };
      this.campanhasPorDia = {
        legends: [],
        data: []
      };
      this.assinaturasPorStatus = [0, 0, 0];

      ajax("post", "gerar_graficos", this.relatorio)
      .then(response => {
        response.qtdVendasPorDia.map(item => {
          this.vendasPorDia.legends.push(item.data);
          this.vendasPorDia.data.push(item.qtd);
        });

        response.qtdVendasPorPlano.map(item => {
          this.vendasPorPlano.legends.push(item.plano);
          this.vendasPorPlano.data.push(item.qtd);
        });

        let campanhas = [];
        response.qtdCampanhasPorDia.map(item => {
          const dateIndex = this.campanhasPorDia.legends.findIndex(date => date === item.data);
          const paramIndex = campanhas.findIndex(param => param === item.param);
          if (dateIndex === -1) this.campanhasPorDia.legends.push(item.data);
          if (paramIndex === -1) campanhas.push(item.param);
        });

        campanhas.map(param => {
          const qtds = [];
          this.campanhasPorDia.legends.map(date => {
            const arrayFiltered = response.qtdCampanhasPorDia.filter(item => item.data === date && item.param === param);
            if (arrayFiltered.length === 1){
              qtds.push(arrayFiltered[0].qtd);
            } else if (arrayFiltered.length > 1) {
              let qtdsSomadas = arrayFiltered.reduce((total, item) => total + item.qtd, 0)
              qtds.push(qtdsSomadas);
            } else if (arrayFiltered.length === 0) {
              qtds.push(0);
            }
          });
          this.campanhasPorDia.data.push({name: param, data: qtds});
        });

        this.vendasBoletoECartao.valor = [Number(response.qtdValorDeVendasPorBoleto[0].valor)/100, Number(response.qtdValorDeVendasPorCartao[0].valor)/100];
        this.vendasBoletoECartao.qtd = [response.qtdValorDeVendasPorBoleto[0].qtd, response.qtdValorDeVendasPorCartao[0].qtd];

        response.assinaturasPorStatus.map(item => {
          switch (item.status) {
            case 'active':
              this.assinaturasPorStatus[0] = item.qtd;
              break;
            case 'overdue':
              this.assinaturasPorStatus[1] = item.qtd;
              break;
            case 'suspended':
              this.assinaturasPorStatus[2] = item.qtd;
              break;
          }
        });

        this.componentKey += 1;
        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;
        tratamento_requisicao(err);
      })
    }
  }
};
</script>

<style scoped>
  .hidden{
    display: none !important;
  }
</style>